var $ = require('jquery');
// var imagesLoaded = require('imagesloadedwithsize');
var imgLoader = require('imgloader');
var NProgress = require('nprogresscustom');

var realSessionStorage = require('realSessionStorage');

var loaderAlreadyDisplayed = false;
var test = realSessionStorage.getItem('loaderAlreadyDisplayed');
console.log('test', test);
if (realSessionStorage.getItem('loaderAlreadyDisplayed') == '1') {
    // loaderAlreadyDisplayed = true;
}
realSessionStorage.setItem('loaderAlreadyDisplayed', '1');

const overlayElement = $('.site__loader__cone').get(0);
const offset = 0;

// 1. Objet d'état avec les valeurs de départ
const coneState = {
    angle: 0,
    rotation: 180 + offset // Pointe vers le bas au départ
};

// 2. Fonction d'application du masque CSS
function renderMask() {
    const startAngle = coneState.rotation - (coneState.angle / 2);
    const maskString = `conic-gradient(from ${startAngle}deg at 50% 50%, transparent 0deg, transparent ${coneState.angle}deg, black ${coneState.angle}deg, black 360deg)`;
    
    overlayElement.style.webkitMaskImage = maskString;
    overlayElement.style.maskImage = maskString;
}

renderMask();

var cb_bu = false;
var loop = 2;

var start = function(cb){
	cb_bu = cb;
	startAnim();
	startTl();
};

var imgs_loaded = false;

let spinTween;
var startTl = function(){
	const tl = gsap.timeline({
	    onUpdate: renderMask // Exécuté automatiquement à chaque frame d'animation
	});
	tl.from( $('.eos-letters path'), {
		opacity : 0,
		ease: 'none',
		duration: 1,
		stagger: 0.1
	} )
	tl.from( $('.eos-baseline path'), {
		opacity : 0,
		ease: 'none',
		duration: 1,
		stagger: 0.1
	}, 0.5 )
	tl.add(function(){
		spinTween = gsap.to(coneState, {
		    rotation: 540 + offset,
		    duration:6,           // Vitesse d'un tour complet (en secondes)
		    ease: "none",          // Vitesse linéaire continue
		    repeat: -1,            // Inifini
		    onUpdate: renderMask
		});
	}, 1.1)
	tl.to(coneState, {
	    angle: 30,         // S'ouvre un peu
	    // rotation: 0,     // Tourne un peu en même temps
	    duration: 1.5,
	    ease: "power2.out"
	}, 1.2)
	tl.add(function(){
		finalStep();
	});
};


var startAnim = function(){
	if ( loaderAlreadyDisplayed ) {
		finalStep();
		return;
	}
	
	// const tl = gsap.timeline({
	//     onUpdate: renderMask // Exécuté automatiquement à chaque frame d'animation
	// });
	// tl.to(coneState, {
	//     angle: 30,         // S'ouvre un peu
	//     // rotation: 0,     // Tourne un peu en même temps
	//     duration: 1.5,
	//     ease: "power2.out"
	// }, 0)
	// tl.addLabel('partB');
	// tl.to(coneState, {
	//     rotation: 900,     // Continue sa rotation
	//     duration: 4,
	//     ease: "none"
	// }, 'partB');
	// tl.to(coneState, {
	//     angle: 360,     // Continue sa rotation
	//     duration: 2,
	//     ease: "none"
	// }, 'partB');
	// loop--;
	// if ( loop > 0 ) {
	// console.log('imgs', $('[data-asset="page"]').get());
	gsap.to( $('.site__loader__img'), 0.5, {opacity:1, ease: Power0.easeOut} );
	// return;
	var update = function(n) {
		// $('.loader__img__prog__bar').get(0).style.left = (n*100)+'%';
		console.log('n', n);
		// gsap.to( $('.loader__rect'), {duration:0.5,xPercent:(n)*100,transformOrigin: '0% 0%'} );
		// gsap.to( coneState, {duration:0.5,angle:(n)*30,onUpdate: renderMask} );
		// TweenMax.set( $('.loader__rect'), {scaleX:n,transformOrigin: '0% 0%'} );
	};

	imgLoader( $('body'), function(){
		// console.log('NProgress.done()');
		// update(1);
		setTimeout(function() {
			NProgress.done();
		}, 100);
	}, progressDone, 10 );

	NProgress.configure({
		'cb': function(el, n){
			update(n);
		},
		'cbDone': function(el){
			update(1);
		},
		'cbEl': '' 
	});
	NProgress.start();
};

var progressDone = function(){
	setTimeout(function() {
		finalStep();
	}, 10);
};
// alert('ok')
var loop = 2;
var finalStep = function () {
	loop--;
	if (loop > 0) {
		return;
	}
	// alert('a')
	// if ( $('.myself').length == 0 ) {
	// 	gsap.to( $('.site__loader__wrap'), {
	// 		scale: 50,
	// 		rotate: 180,
	// 		duration: 30,
	// 	});
	// 	return;
	// }
	// return;
	var tl = new TimelineMax({
		paused : true,
		onUpdate: renderMask
	});
	tl.add( function(){
		cb_bu();
	}, 0 )
	// tl.to( $('.site__loader__bg'), {
	// 	opacity: 0,
	// 	duration: 1,
	// 	// ease: Power0.easeOut
	// 	ease: 'none'
	// }, 0.5 )
	tl.to( $('.site__loader'), {
		opacity: 0,
		duration: 1,
		// ease: Power0.easeOut
		ease: 'none'
	}, 2 )
	tl.to( coneState, {
		angle: 360,
		duration: 1,
		// ease: Power0.easeOut
		ease: 'sine.in'
	}, 2)
	tl.to( $('.site__loader__bg'), {
		opacity: 0,
		duration: 1,
		// ease: Power0.easeOut
		ease: 'none'
	}, 2 )
	// tl.to( $('.site__loader__wrap'), 0.6, {
	// 	opacity: 0,
	// 	// ease: Power0.easeOut
	// 	ease: 'none'
	// })
	
	tl.add( function(){
		setTimeout(function() {
			$('body').addClass('is-loading-done');
		}, 1000);
		spinTween.kill();
		$(window).trigger('loading-done');
		$('.site__loader__wrap').remove();
	} )
	
	tl.play();

};

module.exports = start;
